import React, { Component } from 'react'

import PropTypes from 'prop-types';

import SideCardSty from './SideCard.module.css';

class SideCard extends Component{

    constructor(props){
        super(props);
    }


    render(){
        return(
            <div className={`${SideCardSty.cardDiv} ${this.props.className}`}>
                <div className={SideCardSty.titleSty}>{this.props.title}</div>
                {this.props.children}
            </div>
        );
    };

}


SideCard.propTypes={
    className:PropTypes.string,
    title:PropTypes.string.isRequired,
    
}

export default SideCard;